module.exports = "/_next/static/images/PlanFeatures@2x-23f946595b49bb554ad2efe62ecc4a49.png";